import PhoneIcon from '@mui/icons-material/Phone';
import { Typography, TypographyTypeMap } from '@mui/material';
import { usePathname } from 'next/navigation';

import { TAGLink, resolvePhoneNumberFormat } from '@shared-components-web';
import { useClientInformationStore } from '@src/store';

export default function PhoneNumberLink({
	phoneNumber,
	variant = 'bodySmallBook',
	dataTestId,
	showIcon = false,
}: Readonly<{
	phoneNumber: string;
	variant?: TypographyTypeMap['props']['variant'];
	dataTestId?: string;
	showIcon?: boolean;
}>) {
	const pathname = usePathname();
	const { newClient } = useClientInformationStore((store) => store);

	return (
		<TAGLink
			href={`tel:+1${phoneNumber}`}
			linkSx={{
				textDecoration: 'none',
				'&:hover': {
					textDecoration: 'underline',
				},
			}}
			schedulingDataLayer={{
				event: 'saa_contact_click',
				step_name: pathname,
				visitor_type: newClient ? 'new' : 'existing',
			}}
		>
			<Typography
				component="span"
				color="text.interactive"
				variant={variant}
				sx={
					showIcon
						? {
								display: 'inline-flex',
								alignItems: 'center',
								gap: 0.5,
								verticalAlign: 'middle',
								lineHeight: 'inherit',
						  }
						: { display: 'inline', verticalAlign: 'baseline', lineHeight: 'inherit' }
				}
				{...(dataTestId ? { 'data-test-id': dataTestId } : {})}
			>
				{showIcon ? <PhoneIcon fontSize="inherit" sx={{ fontSize: '1em', verticalAlign: 'middle' }} /> : null}
				{resolvePhoneNumberFormat(phoneNumber)}
			</Typography>
		</TAGLink>
	);
}
